import React, { useEffect } from "react"
import { useForm, SubmitHandler } from "react-hook-form"
import Tab from "@mui/material/Tab"
import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import Box from "@mui/material/Box"
import TodayIcon from "@mui/icons-material/Today"
import RateReviewIcon from "@mui/icons-material/RateReview"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import ResultateTab from "./interwiewTabs/ResultateTab"
import { IFormInputs } from "../../../model/create/CreateInterwiew"
import {
  useAddScheduleInterviewMutation,
  useUpdateScheduleInterviewMutation,
} from "../../../api/InterviewsApi"
import PersonalInformationTab from "./interwiewTabs/PersonalInformationTab"
import InterviewInformationTab from "./interwiewTabs/InterviewInformationTab"
import PersonSearchIcon from "@mui/icons-material/PersonSearch"

import { useSelector } from "react-redux/es/exports"
import { RootState } from "../../../../../app/store"
import { CircularProgress, Tooltip } from "@mui/material"
import { useSnackbar } from "notistack"

const CreateInterwiewTabs = ({
  open,
  setOpen,
  selects,
}: {
  open: any
  setOpen: any
  selects: any
}) => {
  const interviewRow = useSelector((state: RootState) => state.interviewRow)
  const interviewDate = useSelector((state: RootState) => state.interviewDate)
  const interviewMode = useSelector((state: RootState) => state.interviewMode)

  const {
    handleSubmit,
    register,
    formState,
    control,
    watch,
    resetField,
    setValue,
    clearErrors,
  } = useForm<IFormInputs>({
    defaultValues: {
      id: interviewRow.id,
      resultate: {
        status: interviewMode.mode !== "edit" ? 2 : interviewRow.status?.id,
        eliminationStage: interviewRow.resultate.eliminationStage,
        eliminationReason: interviewRow.resultate.eliminationReason,
        eliminationDate: interviewRow.resultate.eliminationDate,
        printingSpeed: interviewRow.resultate.printingSpeed,
        grammar: interviewRow.resultate.grammar,
        interviewResults: interviewRow.resultate.interviewResults, //Результаты собеседования
        trainingResults: {
          startDate: interviewRow.resultate.trainingResults.startDate,
          endDate: interviewRow.resultate.trainingResults.endDate,
          result: interviewRow.resultate.trainingResults.result, // Результаты обучения
        },
        certificationResults: {
          iqs: interviewRow.resultate.certificationResults.iqs,
          testResults: interviewRow.resultate.certificationResults.testResults,
          testResultPercent:
            interviewRow.resultate.certificationResults.testResultPercent, // Результаты атестации
        },
        massRecruiter: interviewRow.massRecruiter?.id,
        training: interviewRow.training?.id,

      },

      personalInformation: {
        fullName: interviewRow.personalInformation.fullName,
        dateOfBirth: interviewRow.personalInformation.dateOfBirth,
        mobilePhone: interviewRow.personalInformation.mobilePhone,
        city: interviewRow.personalInformation.city,
        email: interviewRow.personalInformation.email,
        resume: interviewRow.personalInformation.resume,
        telegram: interviewRow.personalInformation.telegram,
        // newFile: interviewRow.personalInformation.newFile,
        delFile: interviewRow.personalInformation.delFile,
      },

      interviewInformation: {
        department: interviewRow?.department?.id,
        interviewer: interviewRow.interviewer?.id,
        interviewDateTime: interviewRow.timeSlots.id,
        graphType: interviewRow.graphType?.id,
        schedule: interviewRow.schedule?.id,
        workDays: interviewRow.workDays?.id,
        // workDays: {
        //   endDate: interviewRow.workDays.endDate,
        //   startDate: interviewRow.workDays.startDate,
        // },
        project: interviewRow?.project?.id,

        line: interviewRow?.line?.id,
        interviewType: interviewRow?.interviewType?.id,
      },
      paymentRecruiters: {
        lineCame: interviewRow.paymentRecruiters.lineCame,
        lineCameDate: interviewRow.paymentRecruiters.lineCameDate,
        registered: interviewRow.paymentRecruiters.registered,
        registeredDate: interviewRow.paymentRecruiters.registeredDate,
        trainingCompleted: interviewRow.paymentRecruiters.trainingCompleted,
        trainingCompletedDate:
          interviewRow.paymentRecruiters.trainingCompletedDate,
      },
    },
  })

  const { errors } = formState

  const [tabsValue, setTabsValue] = React.useState("1")

  const createTabs = [
    {
      id: "1",
      title: "Результаты и статусы",
      icon: <RateReviewIcon />,
    },
    {
      id: "2",
      title: "Личная информация",
      icon: <PersonSearchIcon />,
    },
    {
      id: "3",
      title: "Информация о собеседовании",
      icon: <TodayIcon />,
    },
  ]

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabsValue(newValue)
  }

  const [
    addScheduleInterview,
    {
      isLoading: addIsLoading,
      isError: addIsError,
      data: addData,
      isSuccess: addisSuccess,
      error: addError,
    },
  ] = useAddScheduleInterviewMutation()
  const [
    updateScheduleInterview,
    {
      isLoading: updateIsLoading,
      isError: updateIsError,
      data: updateData,
      isSuccess: updateisSuccess,
      error: updateError,
    },
  ] = useUpdateScheduleInterviewMutation()

  const [files, setFiles] = React.useState<File[]>([])

  useEffect(() => {
    if (interviewRow.personalInformation.delFile)
      setValue(
        "personalInformation.delFile",
        interviewRow.personalInformation.delFile,
      )
    // if (interviewRow.personalInformation.newFile)
    //   setValue(
    //     "personalInformation.newFile",
    //     interviewRow.personalInformation.file,
    //   )
  }, [files, interviewRow.personalInformation.delFile, setValue])

  const { enqueueSnackbar } = useSnackbar()

  const onSubmit: SubmitHandler<any> = async (data) => {
    try {
      const formData = new FormData()
      const fileList: File[] = Array.from(files)

      fileList.forEach((file) => {
        formData.append(`newFile`, file)
      })

      const appendFormData = (data: any) => {
        formData.append(`data`, JSON.stringify(data))
      }

      appendFormData(data)

      if (interviewMode.mode === "edit") {
        await updateScheduleInterview(formData)
      }

      if (interviewMode.mode === "create") {
        await addScheduleInterview(formData)
      }
    } finally {
      setOpen({
        ...open,
        openCreateInterwiew: false,
        openInterviewsDialog: false,
      })
    }
  }

  useEffect(() => {
    if (addisSuccess) {
      enqueueSnackbar("Собеседование успешно создано", { variant: "success" })
    }
    if (addError && addError !== undefined && "data" in addError) {
      enqueueSnackbar("Не удалось создать собеседование", { variant: "error" })
      if ((addError as any).data.error === "limit schedule")
        enqueueSnackbar(
          "Не удалось создать собеседование, в графике не осталось свободного места",
          {
            variant: "error",
          },
        )
      if ((addError as any).data.error === "double number")
        enqueueSnackbar(
          "Не удалось создать собеседование, кандидат с таким номером телефона уже существует",
          {
            variant: "error",
          },
        )
      if ((addError as any).data.error === "limit slots")
        enqueueSnackbar(
          "Не удалось создать собеседование, в слоте не осталось свободного места",
          {
            variant: "error",
          },
        )

      if (
        (addError as any).data.error !== "limit slots" &&
        (addError as any).data.error !== "double number" &&
        (addError as any).data.error !== "limit schedule"
      ) {
        enqueueSnackbar("Не удалось создать собеседование", {
          variant: "error",
        })
      }
    }
    if (updateisSuccess)
      enqueueSnackbar("Собеседование успешно обновлено", { variant: "success" })
    if (updateIsError && updateError !== undefined && "data" in updateError) {
      if ((updateError as any).data.error === "limit schedule")
        enqueueSnackbar(
          "Не удалось обновить собеседование, в графике не осталось свободного места",
          {
            variant: "error",
          },
        )
      if ((updateError as any).data.error === "double number")
        enqueueSnackbar(
          "Не удалось обновить собеседование, кандидат с таким номером телефона уже существует ",
          {
            variant: "error",
          },
        )
      if ((updateError as any).data.error === "limit slots")
        enqueueSnackbar(
          "Не удалось обновить собеседование, в слоте не осталось свободного места",
          {
            variant: "error",
          },
        )
      if (
        (updateError as any).data.error !== "limit slots" &&
        (updateError as any).data.error !== "double number" &&
        (updateError as any).data.error !== "limit schedule"
      ) {
        enqueueSnackbar("Не удалось обновить собеседование", {
          variant: "error",
        })
      }
    }
  }, [
    addisSuccess,
    updateisSuccess,
    updateIsError,
    addIsError,
    enqueueSnackbar,
  ])

  return (
    <Dialog
      sx={{
        ".MuiDialog-paper": {
          height: "calc(920px - 44px)",
        },
        ".MuiDialogContent-root": {},
        ".MuiDialogActions-root": { px: "36px", pb: "36px" },
      }}
      maxWidth={"lg"}
      open={open.openCreateInterwiew}
      keepMounted
      onClose={() => setOpen({ ...open, openCreateInterwiew: false })}
    >
      <form
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mx: "20px",
            mt: "20px",
            mb: interviewRow.id ? "-15px" : "0px",
          }}
        >
          {"Карточка собеседуемого"}
        </DialogTitle>
        <DialogContent>
          <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"flex-start"}
            sx={{ typography: "body1", mx: "20px" }}
          >
            {interviewRow.id && (
              <Typography
                sx={{
                  fontSize: 14,
                  color: "text.secondary",
                  mb: "10px",
                }}
              >
                ID: {interviewRow.id}
              </Typography>
            )}
            <Stack direction={"column"} spacing={"5px"} sx={{ width: "100%" }}>
              <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                ФИО кандидата *
              </Typography>
              <TextField
                size="small"
                inputProps={register("personalInformation.fullName", {
                  required: "Это поле обязательно для заполнения",
                })}
                fullWidth
                value={watch("personalInformation.fullName")}
                placeholder="ФИО"
                error={!!errors.personalInformation?.fullName}
                helperText={errors.personalInformation?.fullName?.message || ""}
              />
            </Stack>
            <TabContext value={tabsValue}>
              <Box sx={{ mt: "20px" }}>
                <TabList onChange={handleChange}>
                  {createTabs.map((tab) => (
                    <Tab
                      iconPosition="start"
                      key={tab.id}
                      label={
                        <Typography
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "6px",
                            textTransform: "none",
                            fontWeight: "500",
                            fontSize: "14px",
                          }}
                        >
                          {tab.icon} {tab.title}
                        </Typography>
                      }
                      value={tab.id}
                    />
                  ))}
                </TabList>
              </Box>
              <TabPanel sx={{ p: 0, mt: "20px" }} value={"1"}>
                <ResultateTab
                  selects={selects?.data}
                  register={register}
                  formState={formState}
                  watch={watch}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  resetField={resetField}
                />
              </TabPanel>
              <TabPanel sx={{ p: 0, mt: "20px" }} value={"2"}>
                <PersonalInformationTab
                  register={register}
                  formState={formState}
                  watch={watch}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  resetField={resetField}
                  files={files}
                  setFiles={setFiles}
                  uploading={updateIsLoading || addIsLoading}
                  interviewMode={interviewMode}
                  interviewRow={interviewRow}
                />
              </TabPanel>
              <TabPanel sx={{ p: 0, mt: "20px" }} value={"3"}>
                <InterviewInformationTab
                  selects={selects?.data}
                  register={register}
                  formState={formState}
                  watch={watch}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  resetField={resetField}
                />
              </TabPanel>
            </TabContext>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack
            justifyContent={"space-between"}
            sx={{ mx: "8px", width: "480px", mt: "20px" }}
            direction="row"
            spacing={"10px"}
          >
            <Button
              disabled={updateIsLoading || addIsLoading}
              size="large"
              sx={{ fontWeight: "bold" }}
              fullWidth
              variant="outlined"
              onClick={() => setOpen({ ...open, openCreateInterwiew: false })}
            >
              Отмена
            </Button>
            <Box sx={{ width: "100%" }}>
              <Tooltip
                followCursor
                arrow
                title={
                  !watch("personalInformation.fullName") ||
                  !watch("personalInformation.dateOfBirth") ||
                  !watch("personalInformation.city") ||
                  !watch("personalInformation.mobilePhone") ||
                  !watch("personalInformation.email") ||
                  !watch("resultate.massRecruiter")
                    ? "Заполните обязательные поля, чтобы сохранить"
                    : ""
                }
              >
                <span>
                  <Button
                    size="large"
                    disabled={
                      !watch("personalInformation.fullName") ||
                      !watch("personalInformation.dateOfBirth") ||
                      !watch("personalInformation.city") ||
                      !watch("personalInformation.mobilePhone") ||
                      !watch("personalInformation.email") ||
                      !watch("resultate.massRecruiter") ||
                      !watch("personalInformation.telegram") ||
                      updateIsLoading ||
                      addIsLoading
                    }
                    sx={{ fontWeight: "bold", width: "100%", height: "100%" }}
                    variant="contained"
                    type={"submit"}
                  >
                    Сохранить
                  </Button>
                </span>
              </Tooltip>
            </Box>
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateInterwiewTabs
